// extracted by mini-css-extract-plugin
export default {"departments":"NH-z","departmentHeading":"OH-z","departmentSection":"PH-z","departmentName":"QH-z","departmentLink":"RH-z","expandIcon":"SH-z"};